import { Stack, Typography, Box, Tooltip } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

function ActiveAndInactiveDialog({ errorState, handleClose }) {
  const navigate = useNavigate();

  const displayedRecipes = errorState?.errorData?.used_in_recipes?.slice(0, 3);
  const remainingRecipes = errorState?.errorData?.used_in_recipes?.length - 3;

  const displayedIngredients =
    errorState?.errorData?.inactiveIngredients?.slice(0, 3);
  const remainingIngredients =
    errorState?.errorData?.inactiveIngredients?.length - 3;

  const displayedTemplates = errorState?.errorData?.used_in_templates?.slice(
    0,
    3,
  );
  const remainingTemplates =
    errorState?.errorData?.used_in_templates?.length - 3;

  return (
    <>
      <Stack
        px="16px"
        display="flex"
        flexDirection="column"
        sx={{
          overflowY: "auto",
          maxHeight: "60vh",
          minHeight: "100px",

          "-ms-overflow-style": "none",
          "&::-webkit-scrollbar": { display: "none" },
          "&:hover": {
            "&::-webkit-scrollbar": { display: "initial" },
            "-ms-overflow-style": "initial",
          },
        }}
      >
        <Box
          sx={{
            flexGrow: 1,
          }}
        >
          <Typography>{errorState?.errorData?.message}</Typography>
          {errorState?.errorData?.used_in_recipes?.length > 0 && (
            <>
              <Typography mt={2} fontWeight={500}>
                Recipes -
              </Typography>
              <Stack spacing={0.5}>
                {displayedRecipes?.map((recipe, index) => (
                  <Stack
                    direction="row"
                    key={index}
                    spacing={1}
                    alignItems="center"
                  >
                    <Typography
                      component="span"
                      fontSize="14px"
                      color={"#3D4758"}
                    >
                      •
                    </Typography>
                    <Typography
                      component="span"
                      fontSize="16px"
                      color={"#3D4758"}
                      sx={{ textDecoration: "underline", cursor: "pointer" }}
                      onClick={() => {
                        navigate(`/recipe/details/${recipe.id}/?basic-details`);
                        handleClose();
                      }}
                    >
                      {recipe.name}
                    </Typography>
                    {index === displayedRecipes?.length - 1 &&
                      remainingRecipes > 0 && (
                        <Tooltip
                          title={
                            <Stack
                              display="flex"
                              flexDirection="column"
                              spacing={0.5}
                              maxHeight="400px"
                              overflow="hidden"
                              sx={{
                                ":hover": {
                                  overflowY: "auto",
                                },
                              }}
                            >
                              {errorState?.errorData?.used_in_recipes
                                .slice(3)
                                .map((recipes, idx) => (
                                  <Typography
                                    key={idx}
                                    fontSize="14px"
                                    sx={{
                                      textDecoration: "underline",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      navigate(
                                        `/recipe/details/${recipes.id}/?basic-details`,
                                      );
                                      handleClose();
                                    }}
                                  >
                                    {recipes.name}
                                  </Typography>
                                ))}
                            </Stack>
                          }
                          arrow
                          placement="top"
                        >
                          <Typography
                            fontWeight={600}
                            sx={{
                              cursor: "pointer",
                              color: "#000000",
                              fontSize: "16px",
                            }}
                          >
                            +{remainingRecipes} More Recipes
                          </Typography>
                        </Tooltip>
                      )}
                  </Stack>
                ))}
              </Stack>
            </>
          )}
          {/* Templates Section */}
          {errorState?.errorData?.used_in_templates?.length > 0 && (
            <>
              <Typography mt={2} fontWeight={500}>
                Templates -
              </Typography>
              <Stack spacing={0.5}>
                {displayedTemplates?.map((template, index) => (
                  <Stack
                    direction="row"
                    key={index}
                    spacing={1}
                    alignItems="center"
                  >
                    <Typography
                      component="span"
                      fontSize="14px"
                      color={"#3D4758"}
                    >
                      •
                    </Typography>
                    <Typography
                      component="span"
                      fontSize="16px"
                      color={"#3D4758"}
                      sx={{ textDecoration: "underline", cursor: "pointer" }}
                      onClick={() => {
                        navigate(`/templates/details/${template?.id}`);
                        handleClose();
                      }}
                    >
                      {template.name}
                    </Typography>
                    {index === displayedTemplates?.length - 1 &&
                      remainingTemplates > 0 && (
                        <Tooltip
                          title={
                            <Stack spacing={0.5}>
                              {errorState?.errorData?.used_in_templates
                                .slice(3)
                                .map((template, idx) => (
                                  <Typography
                                    key={idx}
                                    fontSize="14px"
                                    sx={{
                                      textDecoration: "underline",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      navigate(
                                        `/templates/details/${template?.id}`,
                                      );
                                      handleClose();
                                    }}
                                  >
                                    {template?.name}
                                  </Typography>
                                ))}
                            </Stack>
                          }
                          arrow
                          placement="top"
                        >
                          <Typography
                            fontWeight={600}
                            sx={{
                              cursor: "pointer",
                              color: "#000000",
                              fontSize: "16px",
                            }}
                          >
                            +{remainingTemplates} More Templates
                          </Typography>
                        </Tooltip>
                      )}
                  </Stack>
                ))}
              </Stack>
            </>
          )}
          {/* Ingredients Section */}
          {errorState?.errorData?.inactiveIngredients?.length > 0 && (
            <>
              <Typography mt={2} fontWeight={500}>
                Ingredients -
              </Typography>
              <Stack spacing={0.5}>
                {displayedIngredients?.map((ingredient, index) => (
                  <Stack
                    direction="row"
                    key={index}
                    spacing={1}
                    alignItems="center"
                  >
                    <Typography
                      component="span"
                      fontSize="14px"
                      color={"#3D4758"}
                    >
                      •
                    </Typography>
                    <Typography
                      component="span"
                      fontSize="16px"
                      color={"#3D4758"}
                      sx={{ textDecoration: "underline", cursor: "pointer" }}
                      onClick={() => {
                        navigate(`/ingredients/details/${ingredient?.id}`);
                        handleClose();
                      }}
                    >
                      {ingredient.name}
                    </Typography>
                    {index === displayedIngredients?.length - 1 &&
                      remainingIngredients > 0 && (
                        <Tooltip
                          title={
                            <Stack spacing={0.5}>
                              {errorState?.errorData?.inactiveIngredients
                                .slice(3)
                                .map((ingredient, idx) => (
                                  <Typography
                                    key={idx}
                                    fontSize="14px"
                                    sx={{
                                      textDecoration: "underline",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      navigate(
                                        `/ingredients/details/${ingredient?.id}`,
                                      );
                                      handleClose();
                                    }}
                                  >
                                    {ingredient?.name}
                                  </Typography>
                                ))}
                            </Stack>
                          }
                          arrow
                          placement="top"
                        >
                          <Typography
                            fontWeight={600}
                            sx={{
                              cursor: "pointer",
                              color: "#000000",
                              fontSize: "16px",
                            }}
                          >
                            +{remainingIngredients} More Ingredients
                          </Typography>
                        </Tooltip>
                      )}
                  </Stack>
                ))}
              </Stack>
            </>
          )}
        </Box>

        {/* Close Button Fixed at Bottom */}
      </Stack>
    </>
  );
}

export default ActiveAndInactiveDialog;
